import type { CreateContractsResponse } from '@vy/api-definition';
import { CreateContractsResponseSchema } from '@vy/api-definition';
import type { NewContractWithPlan } from '@vy/types';
import { CONTRACT_CREATION_TYPES } from '@vy/types';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useCreateContractWithPlan(
  options?: UseMutationOptions<CreateContractsResponse, unknown, NewContractWithPlan['contracts']>,
) {
  return useMutation({
    mutationFn: async (contracts) => {
      const api = getPrivateApi();
      const createContractsResponse = await api.createContracts({
        createContractsRequest: {
          creationType: CONTRACT_CREATION_TYPES.CreateContractWithPlan,
          contracts,
        },
      });

      return CreateContractsResponseSchema.parse(createContractsResponse);
    },
    ...options,
  });
}
